import sha256 from 'crypto-js/sha256';


class Hasher {
    static hash(input: object) {
        let inputString = JSON.stringify(input);
        return sha256(inputString).toString()
    }

    static deepCopy(input: any) {
        return JSON.parse(JSON.stringify(input));
    }

    /**
     * Checks if two arrays contain the same elements, regardless of order.
     */
    static listsEqualUnordered(arr1: any[], arr2: any[]): boolean {
        if (arr1 === arr2) return true;
        if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
        if (arr1.length !== arr2.length) return false;

        const normalize = (arr: any[]) => arr.map(el => 
            (el !== null && typeof el === 'object') 
                ? JSON.stringify(el) 
                : el
        ).sort();
        const aSorted = normalize(arr1);
        const bSorted = normalize(arr2);
        for (let i = 0; i < aSorted.length; i++) {
            if (aSorted[i] !== bSorted[i]) return false;
        }
        return true;
    }
}

export default Hasher
